<template>
  <a-layout id="staff-page">
    <div class="form-staff">

      <header class="form-staff__header">
        <div>
          <div class="form-staff__header--logo">
            <img src="https://www.biboting.cn/wp-content/uploads/2019/06/BIBOTING-LOGO-01.jpg" width="36"
              alt="BIBOTING-LOGO">
            <h3>BIBOTING｜新增晋升资料</h3>
          </div>
          <h3>#{{ editForm.lzyid }}</h3>
        </div>
      </header>
      <main class="content">
        <a-form size="small">
          <div class="form-staff__title">
            <span class="number">1</span>
            <small>个人资料</small>
          </div>
          <a-form-item label="阶级" :label-col="{ span: 24 }" :wrapper-col="{ span: 24 }">
            <div style="width:100%;display:flex">
              <JobLevelRadio v-for="button in jobLevelList.filter((item) => item.level != '')" :key="button.level"
                :level="button.level" :keywords-type="Number(editForm.job_level || 0)" :is-search="false"
                @on-select="handleChangeJobLevel" />
            </div>
          </a-form-item>
          <a-form-item label="姓名" :label-col="{ span: 24 }" :wrapper-col="{ span: 24 }">
            <a-input type="text" v-model="editForm.name"></a-input>
          </a-form-item>
          <a-form-item label="手机" :label-col="{ span: 24 }" :wrapper-col="{ span: 24 }">
            <a-input type="number" v-model.trim="editForm.phone"></a-input>
          </a-form-item>
          <a-form-item label="居住地址" :label-col="{ span: 24 }" :wrapper-col="{ span: 24 }">
            <a-input type="text" v-model="editForm.addr"></a-input>
          </a-form-item>
          <a-form-item label="照片" :label-col="{ span: 24 }" :wrapper-col="{ span: 24 }">
            <div style="display:flex; align-items:center; gap: 0 16px">
              <div v-if="editForm.image" v-viewer  style="cursor:pointer;position:relative;width:120px;aspect-ratio:1;border:1px solid #eee">
              <img id="output" :src="editForm.image" alt="avatar" width="100%" />
              <a-button type="info" style="position:absolute;top:-12px;right:-12px;" size="small"  shape="circle"
                @click.stop="editForm.image = ''" icon="close"></a-button>
            </div>
            <a-upload v-show="!editForm.image" name="avatar" accept="image/jpg" list-type="picture-card" class="avatar-uploader"
              :show-upload-list="false" :before-upload="beforeUpload" :customRequest="customUpload">
              <div>
                <a-icon type="plus" />
              </div>
            </a-upload>
            </div>
          </a-form-item>
          <a-form-item label="生日" :label-col="{ span: 24 }" :wrapper-col="{ span: 24 }">
            <a-date-picker format="YYYY-MM-DD" valueFormat="YYYY-MM-DD" placeholder="请选择生日" :disabled-date="handleDisabledDate" v-model="editForm.birthday" :defaultPickerValue="defaultPickerBirthValue"
              style="width:100%" />
          </a-form-item>
          <div v-show="editForm.job_level >= 3" class="form-staff__title">
            <span class="number">2</span>
            <small>市场资料</small>
          </div>

          <a-form-item v-show="editForm.job_level >= 3" label="主要市场" :label-col="{ span: 24 }"
            :wrapper-col="{ span: 24 }">
            <a-input type="text" v-model="editForm.mainmarket"></a-input>
          </a-form-item>
          <a-form-item v-show="editForm.job_level >= 3" label="次要市场" :label-col="{ span: 24 }"
            :wrapper-col="{ span: 24 }">
            <a-input type="text" v-model="editForm.submarket"></a-input>
          </a-form-item>
          <div v-show="editForm.job_level >= 3" class="form-staff__title">
            <span class="number">3</span>
            <small>配偶资料</small>
          </div>
          <a-form-item v-show="editForm.job_level >= 3" label="配偶名称" :label-col="{ span: 24 }"
            :wrapper-col="{ span: 24 }">
            <a-input type="text" v-model="editForm.spouse_name"></a-input>
          </a-form-item>
          <a-form-item v-show="editForm.job_level >= 3" label="配偶手机" :label-col="{ span: 24 }"
            :wrapper-col="{ span: 24 }">
            <a-input type="number" v-model.trim="editForm.spouse_phone"></a-input>
          </a-form-item>
          <a-form-item v-show="editForm.job_level >= 3" label="配偶生日" :disabled-date="handleDisabledDate" :label-col="{ span: 24 }"
            :wrapper-col="{ span: 24 }">
            <a-date-picker format="YYYY-MM-DD" valueFormat="YYYY-MM-DD" placeholder="请选择配偶生日"
              v-model="editForm.spouse_birthday" style="width:100%" :defaultPickerValue="defaultPickerBirthValue" />
          </a-form-item>
        </a-form>

      </main>
      <footer>
        <a-button class="form-staff__submit" block type="primary" size="large" @click="handleSubmit">送出</a-button>
      </footer>
    </div>

  </a-layout>
</template>
<script type="text/ecmascript-6">
import AInput from 'ant-design-vue/lib/input'
import { DatePicker, Upload } from 'ant-design-vue'
import Message from 'ant-design-vue/lib/message'
import AModal from 'ant-design-vue/lib/modal'
import JobLevelRadio from '@/components/Staff/JobLevelRadio.vue'
import AIcon from 'ant-design-vue/lib/icon'
import dayjs from 'dayjs'
import moment from 'moment'
import 'ant-design-vue/lib/upload/style'
import 'ant-design-vue/lib/date-picker/style'
import 'ant-design-vue/lib/modal/style'
import 'ant-design-vue/lib/message/style'
import 'ant-design-vue/lib/input/style'
import { mapGetters } from 'vuex'
import { pickBy } from 'lodash-es'
import {
  checkHashStaff,
  editStaff
} from '@/api/staff'
export default {
  name: 'StaffForm',
  components: {
    AIcon,
    AInput,
    ADatePicker: DatePicker,
    AUpload: Upload,
    JobLevelRadio
  },
  data () {
    return {
      loading: false,
      editForm: {},
      defaultPickerBirthValue: moment('1980-01-01')
    }
  },
  mounted () {
    this.handleJobLevelList() // 取得职级列表
    this.handleInit()
  },
  computed: {
    ...mapGetters([
      'jobLevelList', // 职级列表
      'staffList', // 经销列表
      'searchStaffParams'
    ]),
    JobLevelRadio () {
      let data = {}
      switch (this.level) {
        case 1:
          data = {
            text: '主任',
            classObject: [
              'search__btn--done',
              'mr-1',
              { 'search__filter--done': this.keywordsType === 1 }
            ]
          }
          break
        case 2:
          data = {
            text: '高级主任',
            classObject: [
              'search__btn--done',
              'mr-1',
              {
                'search__filter--done':
                  this.keywordsType === 2
              }
            ]
          }
          break
        case 3:
          data = {
            text: '经理',
            classObject: [
              'search__btn--done',
              'mr-1',
              { 'search__filter--done': this.keywordsType === 3 }
            ]
          }
          break
        case 4:
          data = {
            text: '高级经理',
            classObject: [
              'search__btn--done',
              'mr-1',
              { 'search__filter--done': this.keywordsType === 4 }
            ]
          }
          break
        case 5:
          data = {
            text: '总监',
            classObject: [
              'search__btn--done',
              { 'search__filter--done': this.keywordsType === 5 }
            ]
          }
          break
        case 6:
          data = {
            text: '6',
            classObject: [
              'search__btn--done',
              { 'search__filter--done': this.keywordsType === 6 }
            ]
          }
          break
        default:
          data = {
            text: '全部',
            classObject: [
              'search__btn--done',
              'mr-1',
              { 'search__filter--done': !this.keywordsType }
            ]
          }
          break
      }
      return data
    }
  },
  methods: {
    beforeUpload (file) {
      const isJpgOrPng =
        file.type === 'image/jpeg'
      if (!isJpgOrPng) {
        Message.error('只能上传 JPG 文件!')
        return false
      }
      const isLt5M = file.size / 1024 / 1024 < 5
      if (!isLt5M) {
        Message.error('原始图片大小需小于 5MB!')
        return false
      }
      return isJpgOrPng && isLt5M
    },
    customUpload (files) {
      let reader = new FileReader()
      reader.onload = function () {
        let output = document.getElementById('output')
        output.src = reader.result
      }
      reader.readAsDataURL(files.file)
      this.editForm.image = files.file
    },

    handleInit () {
      const hash = this.$route.params.hash
      checkHashStaff(hash).then(res => {
        if (res.data.code > 0) {
          this.editForm = res.data.data
          this.editForm.hash = hash
          this.editForm.action = 'editStaff'
        } else {
          AModal.error({
            title: '提示',
            content: res.data.msg,
            keyboard: false,
            centered: true,
            onOk: function () {
              window.location.replace('https://www.biboting.cn/')
            }
          })
        }
      }).catch(error => Message.error(error, 0.5))
    },
    handleJobLevelList () {
      this.isReload = true
      this.$store.dispatch('getJobLevelList').finally(() => {
        this.isReload = false
      })
    },
    handleStaffList (level) {
      const params = this.searchStaffParams
      params.job_level = level
      params.page = 1
      this.$store.dispatch('getStaffList', params)
    },
    handleDisabledDate (current) {
      let year15 = dayjs().subtract(15, 'year').format()
      return current && dayjs(current).format() > year15
    },
    handleChangeJobLevel (level) {
      this.editForm.job_level = level
    },
    handleSubmit () {
      if (!this.editForm.job_level || this.editForm.job_level === '6') return Message.error('请选择阶级', 0.5)
      if (!this.editForm.name) return Message.error('请填写姓名', 0.5)
      if (!this.editForm.phone) return Message.error('请填写手机', 0.5)
      if (!this.editForm.addr) return Message.error('请填写居住地址', 0.5)
      if (!this.editForm.image) return Message.error('请上传照片', 0.5)
      if (!this.editForm.birthday) return Message.error('请填写生日', 0.5)
      if (this.editForm.job_level >= 3) {
        if (!this.editForm.mainmarket) return Message.error('请稍微说明主要市场', 0.5)
        if (!this.editForm.submarket) return Message.error('请稍微说明次要市场', 0.5)
      }
      const formData = new FormData()
      const formatEditForm = pickBy(this.editForm)
      Object.keys(formatEditForm).forEach((key) => {
        formData.append(key, this.editForm[key])
      })
      editStaff(formData).then(res => {
        if (res.data.code > 0) {
          AModal.success({
            title: '提示',
            content: res.data.msg,
            keyboard: false,
            centered: true
          })
        } else {
          AModal.error({
            title: '提示',
            content: res.data.msg,
            keyboard: false,
            centered: true
          })
        }
      }).catch(error => Message.error(error, 0.5))
    }
  }
}
</script>

<style scoped lang="less">
// Color variables (appears count calculates by raw css)
@color0: #f9f9f9; // Appears 10 times
@color1: #d1d9e6; // Appears 9 times
@color2: #ecf0f3; // Appears 6 times
@color3: #a0a5a8; // Appears 2 times
@color4: #4e4d4d; // Appears 2 times

#staff-page {

  background-color: @color2;

}

.form-staff {
  position: relative;
  max-width: 769px;
  width: 100%;
  margin: 20px auto;
  padding: 0;
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  box-shadow: 10px 10px 10px @color1, -10px -10px 10px @color0;

  &__header {
    >div {
      max-width: 769px;
      margin: 0 auto;
      text-align: left;
      display: flex;
      flex-direction: column;
      gap: 24px 0;
    }

    padding: 5rem 2.5em;
    border-bottom: 1px solid #f8f9fa;
    border-radius: 12px 12px 0 0;
    // 透明度 0.3 的黑色半透明遮罩
    background-color: rgba(0, 0, 0, .25);
    // 設置背景混和模式為相乘模式
    background-blend-mode: multiply;
    // background: url(https://biboting.cn/wp-content/uploads/2019/06/Biboting-healthcare-massager-01-1.jpg) right center;
    background-image: url(https://biboting.cn/wp-content/uploads/2019/06/Brand-History-cover-01.jpg);
    background-position: center center;
    background-size: cover;
    background-repeat: no-repeat;

    &--logo {
      display: flex;
      justify-content: flex-start;
      align-items: center;
      gap: 0 12px;
    }

    h3 {
      font-size: 1.2rem;
      font-weight: 900;
      margin: 0;
      color: white;
      letter-spacing: 0.05em;
    }
  }

  &__submit {
    max-width: 780px;
  }

  &__title {
    display: flex;
    align-items: center;
    padding-top: 12px;
    padding-bottom: 12px;

    &:first-child {
      padding-top: 24px;
    }

    .number {
      background-color: @primary-color;
      color: #fff;
      height: 24px;
      width: 24px;
      display: inline-block;
      font-size: 0.8em;
      line-height: 24px;
      text-align: center;
      text-shadow: 0 1px 0 rgba(255, 255, 255, 0.2);
      border-radius: 5px;
    }

    small {
      padding: 0 8px;
      cursor: default;
      font-weight: 500;
      letter-spacing: .05em;
      font-size: 1rem;
      color: #000;
    }
  }
}

header,
footer {
  padding: 12px 20px;
  text-align: center;
  width: 100%;
}

footer {
  padding: 0px;
  z-index: 10;
  position: fixed;
  left: 0;
  bottom: 0;
  background-color: @color2;
}

.content {
  flex-grow: 1;
  margin-bottom: 70px;
  // background: #f8f9fa;
  // background: #f0f1f2;
  padding: 0 12px;
  border-radius: 0 0 8px 8px;
}
</style>
